const enum DatasetEnum {
  MY_ORDER_LIST = "/system/task/taskList",
  MY_ORDER_DETAIL = "/system/task/taskDetail",
  MY_ORDER_REFUND = "/system/task/task_withdraw",
  PUT_DATA = "/task/new/saveTask",
  GET_FORMARD_RESULT = "/dataset/queryForwardResult",
  SUBMIT_FEEDBACK = "/system/task/submitFeedback",
  PAY_STATUS = "/system/task/queryPayStatus",
  GET_CACHE_ORDER = "/login/queryOrderCache",
  USE_ORDER = "/unused/order/use",
  QUERY_NEWEST_TASK = "/system/task/queryNewestTask",
}
export default DatasetEnum;
